import tr from './tr';
import en from './en';

export default { tr, en }


// WEBPACK FOOTER //
// ./src/plugins/i18n/locales/index.js